<div class="wrapper d-flex justify-content-between {{ _config.cssClass }}">
  <div *ngIf="_config?.label" class="d-flex align-items-center t-footnote-regular">{{ _config.label }}</div>
  <input
    [checked]="false"
    [formControl]="ngControl.control"
    [id]="id"
    class="tgl tgl-ios"
    type="checkbox"
    [class.dark-theme]="(_currentThemeSubject | async) === 'dark'"
    [class.light-theme]="(_currentThemeSubject | async) === 'light'"
  />
  <label class="tgl-btn ml-8" [for]="id"></label>
</div>
